import { useState, useEffect } from "react";
import { Col } from "react-bootstrap";
import GridCard from "../../../components/shared/gridCard/GridCard";
import Datatable from "../../../components/shared/datatable/Datatable";
import Button from "../../../components/shared/buttons/button";
import DateSelector from "../../../components/shared/fields/DateSelector";
import useTranslator from "../../../hooks/useTranslator";
import KgGreen from "../../../images/kg_green.svg";
import PendingCase from "../../../images/pendingCase.svg";
import KgRejected from "../../../images/kg_rejected.svg";
import { useGetCartSummaryOverviewQuery, useGetUsedCartLogQuery , useGetCartWasteMaterialQuery, useGetCartPendingLogQuery } from "./cartApi";
import { convertToUserTimezone, getCurrentDate, formatDateAndTime, makePriorLotNumber, formatNumber } from "../../../helpers/Utils";
import { PROJECT_DATE_FORMAT } from "../../../helpers/constants";
import { PlusSvg } from "../../../svgFiles/PlusSvg";
import CartMaterialModal from "./CartMaterialModal";
import CartWasteModal from "./CartWasteModal";
import CartPendingModal from "./CartPendingModal";

const Cart = () => {
  const { _t } = useTranslator();
  const currentDate = getCurrentDate("YYYY-MM-DD");
  const [date, setDate]           = useState(currentDate);
  const [lotNumber, setLotNumber] = useState(makePriorLotNumber(currentDate));
  const [page, setPage]           = useState(1);
  const [showAddModal, setShowAddModal]       = useState(false);
  const [showEditPendingModal, setShowEditPendingModal] = useState(false);
  const [showWasteModal, setShowWasteModal]   = useState(false);
  const [wasteType, setWasteType]             = useState("cart_waste");
  const [selectedRecord, setSelectedRecord]   = useState(null);
  const [modalMode, setModalMode]             = useState("add");

  const handleOpenAdd  = () => { setSelectedRecord(null); setModalMode("add");  setShowAddModal(true); };
  const handleOpenEdit = (row) => {
    setSelectedRecord(row);
    setModalMode(row.status === "pasting_done" ? "view" : "edit");
    setShowAddModal(true);
  };

  useEffect(() => { setLotNumber(makePriorLotNumber(date)); }, [date]);

  const { data: summaryData } = useGetCartSummaryOverviewQuery({ date, batch_code: lotNumber });
  const { data: logsData, isLoading, isFetching } = useGetUsedCartLogQuery({
    page,
    date,
    batch_code: lotNumber,
  });

  //  Cart Waste MAterial 

  const { data: wasteMaterialLogData, isLoading: wasteLoading, isFetching:wasteFetching } = useGetCartWasteMaterialQuery({
    batch_code: lotNumber,
    waste_type : ['cart_waste','pasting_waste']
  });

  // Cart Pending Log
  const { data: cartPendingLog } = useGetCartPendingLogQuery(
    { batch_code: lotNumber },
    { skip: !lotNumber }
  );

  const cartPendingRecord = cartPendingLog?.data?.find(
    (r) => r.material_key === "cart_material" && r.belongs_to === "cart"
  ) ?? null;
  console.log(cartPendingRecord)

  const morningCartWaste =
    wasteMaterialLogData?.data?.find(
      item => item.shift === "morning" && item.waste_type === "cart_waste"
    )?.weight_in_kg ?? 0;

  const eveningCartWaste =
    wasteMaterialLogData?.data?.find(
      item => item.shift === "evening" && item.waste_type === "cart_waste"
    )?.weight_in_kg ?? 0;

  const morningPastingWaste =
    wasteMaterialLogData?.data?.find(
      item => item.shift === "morning" && item.waste_type === "pasting_waste"
    )?.weight_in_kg ?? 0;

  const eveningPastingWaste =
    wasteMaterialLogData?.data?.find(
      item => item.shift === "evening" && item.waste_type === "pasting_waste"
    )?.weight_in_kg ?? 0;
  
   

  const listItems = [
    {
      label: _t("total_entered_weight", "Total Entered Weight"),
      value: `${formatNumber(summaryData?.data?.total_weight_ready_for_cart ?? 0 ,0)} kg`,
      icon: KgGreen,
    },
    {
      label: _t("total_cart_pending", "total_Cart Pending"),
      value: summaryData?.data?.total_cart_pending ?? 0,
      icon: KgGreen,
      // showDay : false
    },
    {
      label: _t("total_cart_completed_pasting", "Total Cart Completed"),
      value: summaryData?.data?.total_cart_completed ?? 0,
      icon: KgGreen,
      // showDay : false
    },
    {
      label: _t("pasting_pending_kg", "Pasting Pending KG"),
      value: `${formatNumber(summaryData?.data?.pending_details?.material_unit ?? 0 ) ?? 0} kg`,
      icon: KgGreen,
      extra_info: true,
      info_message:  `${summaryData?.data?.pending_details?.material_description ?? ''}`,
    },
    {
      label: _t("total_kg_in_pasting", "Total KG In Pasting"),
      value: `${formatNumber(summaryData?.data?.total_kg_in_pasting || 0 ,0) } kg`,
      icon: KgGreen,
    },
    {
      label: _t("total_pasting_done", "Total Pasting Done (KG)"),
      value: `${formatNumber(summaryData?.data?.total_pasting_done || 0 ,0) } kg`,
      icon: KgGreen,
    },
    {
      label: _t("total_cart_waste", "Total Cart Waste"),
      value: `${formatNumber(summaryData?.data?.total_cart_waste || 0 ,0) } kg`,
      icon: KgGreen,
    },
    {
      label: _t("total_pasting_waste", "Total Pasting Waste"),
      value: `${formatNumber(summaryData?.data?.total_pasting_waste || 0 ,0) } kg`,
      icon: KgGreen,
    }
  ];

  const columns = [
    {
      label: _t("entered_date", "Entered Date"),
      accessor: "entered_date_time",
      cell: ({ value }) => (value ? convertToUserTimezone(value) : "—"),
    },
    {
      label: _t("cart_name", "Cart Name"),
      accessor: "cart_name",
      cell: ({ value }) => (value != null ? `${value}` : "—"),
    },
    {
      label: _t("trays_count", "Trays Count"),
      accessor: "no_of_treys",
      cell: ({ value }) => (value != null ? value : "—"),
    },
    {
      label: _t("actual_weight_before", "Actual Weight Before"),
      accessor: "actual_weight_before",
      cell: ({ value }) => (value != null ? value : "—"),
    },
    {
      label: _t("actual_weight_after", "Actual Weight After"),
      accessor: "actual_weight_after",
      cell: ({ value }) => (value != null ? value : "—"),
    },
    {
      label: _t("moisture_percent", "% Moisture"),
      accessor: "moisture_percent",
      cell: ({ value }) => (value != null ? `${value}%` : "—"),
    },
    {
      label: _t("water_activity", "Water Activity"),
      accessor: "water_activity",
      cell: ({ value }) => (value != null ? value : "—"),
    },
    {
      label: _t("evaporation_prcnt", "Evaporation %"),
      accessor: "evaporation_percentage",
      cell: ({ value }) => ( value != null ? `${value}%` : "---"),
    },
    {
      label: _t("status", "Status"),
      accessor: "status",
      cell: ({ value }) => {
        if (!value) return "—";
        const badgeClass =
          value === "pasting_done"  ? "cmn_badge"
          : value === "in_pasting"  ? "cmn_badge inactive"
          : "cmn_badge inactive";
        const label =
          value === "at_rest"       ? _t("status_at_rest",       "At Rest")
          : value === "cart_unloaded" ? _t("status_cart_unloaded", "Cart Unloaded")
          : value === "in_pasting"  ? _t("status_in_pasting",    "In Pasting")
          : value === "pasting_done" ? _t("status_pasting_done", "Pasting Done")
          : value;
        return <span className={badgeClass}>{label}</span>;
      },
    },
    {
      label: _t("action", "Action"),
      accessor: "id",
      cell: ({ row }) => {
        const isView = row.status === "pasting_done";
        return (
          <Button
            size="small"
            label={isView ? _t("view", "View") : _t("edit", "Edit")}
            className={isView ? "borderRedBtn" : ""}
            onClick={() => handleOpenEdit(row)}
          />
        );
      },
    },
  ];

  return (
    <div>
      {showAddModal && (
        <CartMaterialModal
          show={showAddModal}
          setShow={setShowAddModal}
          batchCode={lotNumber}
          record={selectedRecord}
          mode={modalMode}
        />
      )}
      {showWasteModal && (
        <CartWasteModal
          show={showWasteModal}
          setShow={setShowWasteModal}
          batchCode={lotNumber}
          wasteType={wasteType}
          className={"sm-modal"}
        />
      )}
      {showEditPendingModal && (
        <CartPendingModal
          show={showEditPendingModal}
          setShow={setShowEditPendingModal}
          batchCode={lotNumber}
          record={cartPendingRecord}
        />
      )}

      {/* Overview tiles */}
      <div className="overview cmn_card mb-3">
        <div className="overview_header d-flex gap-2 align-items-center">
          <h6 className="mb-0 flex-grow-1">
            {_t("cart_overview", "Cart Overview")}
          </h6>
          <div className="d-flex gap-2 align-items-center">
            <h6 className="mb-0">{_t("batch_code", "Batch Code")}</h6>
            <Button label={`#${lotNumber ?? 0}`} size="small" className="borderRedBtn" />
            <DateSelector setDate={setDate} />
          </div>
        </div>
        <ul className="m-0 grid_card_wrapper">
          {listItems.map((list, index) => (
            <GridCard
              key={index}
              title={list.label}
              value={list.value}
              icon={list.icon}
              day={currentDate === date ? _t("common_today", "Today") : formatDateAndTime(date, PROJECT_DATE_FORMAT)}
              extra_info={list.extra_info}
              info_message={list.info_message}
              showDay = {list.showDay}
            />
          ))}
        </ul>
      </div>

      {/* Two-column layout: table left, pending + waste right */}
      <div className="d-flex gap-2">
        {/* ── Left: Cart log table ── */}
        <Col lg={9}>
          <Datatable
            title={_t("cart_log", "Cart Log")}
            columns={columns}
            tableData={logsData?.data}
            buttons={ date === currentDate ? [
              {
                label: _t("add_material", "Add Material"),
                onClick: () => handleOpenAdd(),
                icon: PlusSvg,
              },
            ] : []}
            pagination
            page={page}
            onPageChange={setPage}
            isLoading={isLoading || isFetching}
          />
        </Col>

        {/* ── Right: Pending Material + Waste Material Log ── */}
        <Col lg={3}>
          {/* Pending Material */}
          <div className="overview mb-3">
            <div className="d-flex gap-2 align-items-center pb-4">
              <h5 className="flex-grow-1 mb-0">{_t("pending_material", "Pending Material")}</h5>
            </div>
            <ul className="overview cmn_card m-0 grid_sorting_wrapper">
              <GridCard
                title={_t("pasting_pending", "Pasting Pending")}
                value={`${cartPendingRecord?.material_unit ?? 0} kg`}
                icon={PendingCase}
                showEdit={date === currentDate ? true : false}
                onEdit={() => setShowEditPendingModal(true)}
              />
            </ul>
          </div>

          {/* Waste Material Log */}
          <div className="overview cmn_card mb-3">
            <div className="overview_header d-flex gap-2 align-items-center p-3">
              <div className="flex-grow-1">
                <h6 className="mb-0">{_t("waste_material_log", "Waste Material Log")}</h6>
              </div>
            </div>

            <div className="p-2">
              {/* Cart Waste Material */}
              <div className="rejected-card mb-3">
                <div className="d-flex align-items-center gap-3">
                  <div className="rejected-icon">
                    <img src={KgRejected} alt="Cart Waste" style={{ width: "48px", height: "48px" }} />
                  </div>
                  <div className="flex-grow-1">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h6 className="mb-0" style={{ fontSize: "14px", color: "#666" }}>
                        {_t("cart_waste", "Cart Waste")}
                      </h6>
                      { date === currentDate && 
                        <Button
                          size="xs"
                          label={_t("update", "Update")}
                          onClick={() => { setWasteType("cart_waste"); setShowWasteModal(true); }}
                        />
                      }
                    </div>
                    <div className="d-flex gap-3">
                      <div className="rejected-shift-data">
                        <span style={{ fontSize: "12px", color: "#999" }}>{_t("morning", "Morning")}</span>
                        <h5 className="mb-0" style={{ fontSize: "20px", fontWeight: "600" }}>
                          {morningCartWaste ?? 0}
                        </h5>
                      </div>
                      <div className="rejected-shift-data">
                        <span style={{ fontSize: "12px", color: "#999" }}>{_t("evening", "Evening")}</span>
                        <h5 className="mb-0" style={{ fontSize: "20px", fontWeight: "600", color: "#ee7225" }}>
                          {eveningCartWaste ?? 0}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Pasting Waste Material */}
              <div className="rejected-card">
                <div className="d-flex align-items-center gap-3">
                  <div className="rejected-icon">
                    <img src={KgRejected} alt="Pasting Waste" style={{ width: "48px", height: "48px" }} />
                  </div>
                  <div className="flex-grow-1">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h6 className="mb-0" style={{ fontSize: "14px", color: "#666" }}>
                        {_t("pasting_waste", "Pasting Waste")}
                      </h6>
                      {date === currentDate && 
                        <Button
                          size="xs"
                          label={_t("update", "Update")}
                          onClick={() => { setWasteType("pasting_waste"); setShowWasteModal(true); }}
                        />
                      }
                    </div>
                    <div className="d-flex gap-3">
                      <div className="rejected-shift-data">
                        <span style={{ fontSize: "12px", color: "#999" }}>{_t("morning", "Morning")}</span>
                        <h5 className="mb-0" style={{ fontSize: "20px", fontWeight: "600" }}>
                          {morningPastingWaste ?? 0}
                        </h5>
                      </div>
                      <div className="rejected-shift-data">
                        <span style={{ fontSize: "12px", color: "#999" }}>{_t("evening", "Evening")}</span>
                        <h5 className="mb-0" style={{ fontSize: "20px", fontWeight: "600", color: "#ee7225" }}>
                          { eveningPastingWaste ?? 0}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </div>
    </div>
  );
};

export default Cart;
